(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-bf-hero-slider]';

    function initBfHeroSlider(root) {
      if (! root || typeof Swiper === 'undefined') return;
      

      const slider = root.querySelector('.bf-hero-slider__swiper');
      if (! slider || slider.swiper) return;
      

      const slides = slider.querySelectorAll('.swiper-slide');
      if (slides.length<= 1) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayDelay = Number(root.dataset.autoplayDelay) || 5000;

    new Swiper(slider, {
      slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, loop: true, speed: reducedMotion ? 0 : 650, grabCursor: true, autoplay: reducedMotion ? false : {
        delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: true
      }, pagination: {
        el: root.querySelector('.swiper-pagination'), clickable: true
      }, a11y: {
        enabled: true
      }
    });
  }

  function initBfHeroSliders(scope = document) {
    if (scope.matches?.(selector)) initBfHeroSlider(scope);
    scope.querySelectorAll?.(selector).forEach(initBfHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBfHeroSliders(), {once: true}) 
      
    } else {
      initBfHeroSliders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initBfHeroSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches ?. (selector)
        ? event.target
        : event.target.querySelector ?. (selector);
      const slider = root ?. querySelector('.bf-hero-slider__swiper');
      slider ?. swiper ?. destroy(true, true);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-bf-slide]');
      const root = event.target.closest(selector);
      const swiper = root ?. querySelector('.bf-hero-slider__swiper') ?. swiper;

      if (! slide || ! swiper) return;
      

      const index = Number(slide.dataset.slideIndex);
      swiper.slideToLoop(index, 0);
      swiper.autoplay ?. stop();
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target.closest(selector);
      const swiper = root ?. querySelector('.bf-hero-slider__swiper') ?. swiper;
      swiper ?. autoplay ?. start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
